import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc, where } from "firebase/firestore"

const getAllEmpresas = async () => {
  const empresasRef = collection(db, "empresas");
  const params = []
  const empresasList = []
  params.push(where("active", "==", true))
  const q = query(empresasRef, ...params);
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    empresasList.push({ id: doc.id, ...doc.data() })
  })
  return empresasList;
}

const saveEmpresa = async (payload) => {
  const colRef = collection(db, 'empresas')
  await addDoc(colRef, payload)
}

const deleteEmpresa = async (payload) => {
  const colRef = await doc(db, 'empresas', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

const updateEmpresa = async (payload) => {
  const colRef = await doc(db, 'empresas', payload.id);
  await updateDoc(colRef, payload);
}

export { getAllEmpresas, saveEmpresa, updateEmpresa, deleteEmpresa }
